import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../demo.service';
import { DataService } from './data.service';

// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SelectionSettingsModel, SortService, TextWrapSettingsModel, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager  } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import {  IFilter } from '@syncfusion/ej2-angular-grids';
import {  ToolbarItems, GroupSettingsModel,
RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { TabsetComponent } from 'ngx-bootstrap';

// import {Column } from '@syncfusion/ej2-ng-grids';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { HotToastService } from '@ngneat/hot-toast';
import { Brand } from 'src/app/api/brand';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';

@Component({
  selector: 'app-system-log-manager',
  templateUrl: './system-log-manager.component.html',
  styleUrls: ['./system-log-manager.component.css'],
  providers: [DataService, ToolbarService, PdfExportService, PageService, FilterService, SortService]
})
export class SystemLogManagerComponent implements OnInit {

  // public logs$: Observable<SystemLog[]>;
  // Normal Layout
  logs$: Observable<any>;
  logs: any;

  // for grid so it has change events.
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  @ViewChild('grid')
  public grid: GridComponent;

  @ViewChild('grid2')
  public grid2: GridComponent;

  public wrapSettings: TextWrapSettingsModel; // { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both
  public datePickerObj: DatePicker;
  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
    // TABS sets the selected
    @ViewChild('staticTabs') staticTabs!: TabsetComponent;
    selected_tab?: number;
 
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  searchOptions: {};
  initialPage: { pageSize: number; };
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  live_IP_Access_log_data: any;
  formatOptions: { type: string; format: string; };
  logs_search: Object;

  combo_model: Brand;
  search_model: SystemLog;
  brands_client: any;
  brands_agent: any;
  users: Object;
  brand_types: any;
  user_levels: any;
  system_log_types: any;

  // Need to create a different type of data service?
  // see: https://ej2.syncfusion.com/angular/documentation/grid/observables/
  public dataStateChange(state: DataStateChangeEventArgs): void {
    this.service.execute(state);
  }

// ... additions for datepicker column for sycfusion grid
  //public data: Object[];
  //public ddldata: Object[];
  //public pageOptions: Object;
  public category: string[];
  //public templateOptionsDate: IFilterUI;
  //public elem1: HTMLElement;
  //public datePickerObj: DatePicker;

  // maps the appropriate column to fields property
// public fields: Object = { text: 'Game', value: 'Id' };
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  DialogObj: any;

  // My Custom Logger Class.PHP - Same as BackVault.
  private _jsonURL_slim_api = 'https://api.sharmans.net.au/slimapp/public/' + 'live_IP_Access_log.txt';

  constructor(
    private _demoService: DemoService,
    public service: DataService,
    private route: ActivatedRoute, private router: Router,
    public gfunc: GlobalFunctionsService,
    private http: HttpClient,
    public toastr: HotToastService,
  ) {
   // this.logs$ = this._demoService.fetchSystemLog(); loads the observable without a function

    // Setup Grid
    // , {
      // text: 'TRY ME!',
      // tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Clic2k'
    // }
    this.toolbarOptions = ['ExcelExport', 'Search'];
    // this.toolbar = [
    // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

  //  this.initialPage = { pageSize: 100 };
    this.filterOptions = {
      type: 'Menu'
    };
    this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
    // this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
    // this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
    // this.dateFormat = 'dd/MM/yyyy';
     this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };


    this.initialPage = { pageSize: 100 };
    this.filterOptions = {
    type: 'Menu'
    };

    // this.groupOptions = { columns: ['id'] }; // sets auto grouping for the grid
    this.groupOptions = { }; // sets auto grouping for the grid

    this.formatoptions = {type: 'date', format: 'dd/MM/yyyy'};
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    // this.filter = { params: { format: this.dateFormat } };
    // this.sortOptions = { columns: [ ] };

    //checkbox selection options
    this.selectionOptions = {type: 'Multiple', checkboxOnly: true,}; // type: 'Multiple', mode: 'Both // checkboxMode: 'ResetOnRowClick'
    // this.selectionOptions = { type: 'Multiple', mode: 'Both'}; // 


    this.wrapSettings = { wrapMode: 'Content' };
    this.searchOptions = {  };



// More Date Upgards 2022 syncfsion grid
    // this.templateOptionsDate = {
    //   create: () => {
    //     this.elem1 = document.createElement('input');
    //     return this.elem1;
    //   },
    //   write: (args) => {
    //     this.datePickerObj = new DatePicker({
    //       value: new Date(args.column.field),
    //       floatLabelType: 'Never',
    //       change: this.sync_changes.bind(this), // this is a function see below.
    //     });
    //     this.datePickerObj.appendTo(this.elem1);
    //   }
    // }   





// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));




  }


  
  ngOnInit() {

    // Get Slim API Logs // Did not work direct access due to cors issues..... 
    // this.getJSON().subscribe(data => {
    //   let res = data;
    //   this.live_IP_Access_log_data = res;
    //   console.log('Slim API: ' + data);
    //  });







   // const state = { skip: 0, take: 10 };
   // this.service.execute(state);


     // do a call to fetch the users on init of component
    // the fetchUsers method returns an observable
    // which we assign to the users$ property of our class
    // this.users$ = this.client.fetchUsers()
 // this.logs$ = this._demoService.fetchSystemLog(); // async instead of a function below.
  this.getLogs();
  this.search_model = new SystemLog();
  // this.getLogsSearch(this.search_model)
  this.getBrandsComboBoxClients(this.combo_model); // gets all brands
  this.getUsers();
  this.getBrandTypes();
  this.getFormUserLevels();
  this.getSystemLogTypes();
  }


// syncfusion grid data function
    // sync_changes(args) {
    //   let targEle: any = parentsUntil(args.element, 'e-filtertext');
    //    let columnName : string = targEle.id.replace('_filterBarcell', '');
    //  if (args.value) {
      
    //    this.grid.filterByColumn(columnName, 'equal', args.value);
      
    //  } else {
    //   this.grid.removeFilteredColsByField(columnName);
    //  }
    // }



    public getLogsSearch(search_model) {
      this._demoService.fetchSystemLogSearch(search_model)
      .pipe(
        this.toastr.observe({
          loading: 'loading...',
          success: '🚀',
          error: '...😡...'
       })
       )
      .subscribe(
        (res) => (
          this.logs_search = res,
          this.grid2.refresh()
          ),
        (err) => console.error(err.status)
      );
    } /* */



  private getLogs() {
    this._demoService.fetchSystemLog().subscribe(
      (res) => (this.logs = res),
      (err) => console.error(err.status)
    );
  } /* */

// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
      this.grid2.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.logs }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}


subjectEditLink(subject_id) {
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  this.gfunc.globalJobSubjectView(subject_id);
}


  
refreshGrid(){ // refresh the databutton
  this.getLogs();
  this.grid.refresh();
};


  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
    this.selected_tab = tab_id; // so that we can load the queries only when the tabs clicked
  };


// Get API Logs
public getJSON(): Observable<any> {
  return this.http.get(this._jsonURL_slim_api);
}





// grid search buttons
searchGridColStatus(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['status'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}



searchGridColCreatedVia(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['created_via'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}


searchGridRemaining(string) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['status'], operator: 'contains', key: 'processing', ignoreCase: true };
  // now refresh the grid
  this.grid2.refresh();
}

searchGridColTotalAbove(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['total'], operator: 'greaterThanOrEqual', key: 65, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}



searchGridMail(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['shipping_total'], operator: 'lessThanOrEqual ', key: .01, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}


searchGridCP(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid2.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['shipping_total'], operator: 'greaterThanOrEqual ', key: 1, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}

clearSearchGrid() {
  this.grid2.searchSettings.key = '';
}

searchGrid(name) {
  this.searchOptions = {  };
  this.grid2.searchSettings.key = '';
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  const searchText: string = name;
  this.grid2.search(searchText);

}


clickHandlerRIS() {
  this.grid2.enablePersistence = false;
  window.localStorage.setItem("gridGrid", "");
  this.grid2.destroy();
  //reloads the page
  location.reload();
}





// getReportSubjectsUrgentSearchClient(search_model) {
//   this.brand_user_join_results = [];
//   this.subjects_urgent = [];
//   this.grid.searchSettings.key = ''; // resets the grid filters and buttons
  
// //  search_model.brand_type_id = 2;
// //  search_model.access_level = 9;
//    search_model.brand_report_id = this.brand_id // so that only this client brands will show.
  
//   this._demoService.getReportSubjectsUrgentSearchClient(search_model).subscribe(
//       data => { this.brand_search = data;
//         // pass so that the dates are correct in Sync
//         // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
//         this.brand_search_results = DataUtil.parse.parseJson(data); 
//   // get the users as well and join the records together

//   // Run this function and use the same json object and keep adding or removing to it if you wish.
//   //    this.getReportUsersSearch(search_model);
  
//   // now how to join two arrays of objects.
//   // maybe pass results in to a new model.
  
//   // Count items of brand search to loop through
//                                   let  count_of_brand_items = Object.keys(this.brand_search).length;
//                                   // now loop and push to join model
//                                   for(let i=0;i < count_of_brand_items; i++) {
//                                     let res = this.brand_search_results[i];
                                  
//                                       // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
//                                       this.brand_user_join_results.push({
//                                         email_address: res.email,
//                                         first_name: res.name,
//                                         surname: res.surname,
//                                         company_name: res.name,
//                                         created: res.created,
//                                               });

//                           this.subjects_urgent.push({
//                             // email_address: res.email,
//                             // first_name: res.name,
//                             // surname: res.surname,
//                             // company_name: res.name,
//                             // created: res.created,
//                             ...this.brand_search_results[i]
//                                   });

                                  
//                                   } // end brands loop.
                                  
//                                   this.brand_user_join_results = this.brand_user_join_results;
//                                   this.subjects_urgent = this.subjects_urgent;
  
//        this.grid.refresh();
//       },
//       error => {
//       console.error('Error Loading !' + error.error);
//       console.log(error);
//       // return Observable.throw(error);
//       }

//     ); }






addDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return futureDate;
  }
  
  
  removeDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - days);
  return futureDate;
  }

  getBrandsComboBoxClients(combo_model) {
    // this.combo_model.brand_id = 2;
   this._demoService.getBrands().subscribe(
      data => { this.brands_client = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  // getBrandsComboBoxClients(combo_model) {
  //   // this.combo_model.brand_id = 2;
  //  this._demoService.getBrandsComboBox(combo_model).subscribe(
  //     data => { this.brands_client = data; },
  //     err => console.error(err),
  //     // () => console.log('done loading Trace Types')
  //   );
  // }
  
  getBrandsComboBoxAgents(combo_model) {
   this.combo_model.brand_id = 3;
  this._demoService.getBrandsComboBox(combo_model).subscribe(
     data => { this.brands_agent = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
  }
  
  
  

getUsers() {
  this._demoService.getUsers().subscribe(
     data => { this.users = data; },
     err => console.error(err),
     () => console.log('done loading users')
   );
 }
  
  
  // syncfusion dialog simple sample
  public onOpenDialog = function(event: any): void {
    this.DialogObj = DialogUtility.confirm({
      title: 'New CLient or a Login User',
      content: 'Create New - Not Currently Activated Yet!.',
      okButton: {  text: 'Ok', click: this.okClick.bind(this) },
      cancelButton: {  text: 'Cancel.', click: this.cancelClick.bind(this) },
      showCloseIcon: true,
      closeOnEscape: true,
      animationSettings: { effect: 'Zoom' }
  });
  }
  private okClick(): void {
   //  alert('you clicked Yes, Please! are you really really sure??? Really');
   // this.createJobSubjectsMultiple(this.JSON_job);
  // this.createJobSubjectsMultiple(this.newSubject);
   this.DialogObj.hide();
  }
  
  private cancelClick(): void {
     // alert('you clicked Cancel button');
     this.DialogObj.hide();
  }
  


  // Functions
  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }

   getBrandTypesNoOwner() {
    this._demoService.getBrandBrandTypesNoOwner().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }


   getFormUserLevels() {
    this._demoService.getFormUserLevels().subscribe(
       data2 => { this.user_levels = data2;
        console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Levels')
     );
   }


   getSystemLogTypes() {
    this._demoService.getSystemLogTypes().subscribe(
       data2 => { this.system_log_types = data2;
        console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Levels')
     );
   }

}
